import React from 'react';
import ReactApexChart from 'react-apexcharts';

function BarChart({ title, series, labels }) {
    // Define your primary gradient color variables
    const barPrimary = {
        start: 'var(--barGradientStart)',
        end: 'var(--barGradientEnd)',
    };

    const [chartData] = React.useState({
        series: [
            {
                name: title,
                data: series, // Use the series array directly for one value per label
            },
        ],
        options: {
            chart: {
                type: 'bar',
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false, // Set to true for horizontal bars if desired
                    columnWidth: '30%',
                    borderRadius: 5,
                },
            },
            fill: {
                type: 'gradient', // Enable gradient fill
                gradient: {
                    shade: 'light', // Options: 'light', 'dark'
                    type: 'vertical', // Options: 'vertical', 'horizontal', 'diagonal1', 'diagonal2'
                    shadeIntensity: 0.5,
                    gradientToColors: [barPrimary.end], // Use variable for end color
                    inverseColors: false,
                    opacityFrom: 0.9,
                    opacityTo: 0.7,
                    stops: [0, 100], // Gradient stop points
                },
            },
            colors: [barPrimary.start], // Use variable for start color
            dataLabels: {
                enabled: true,
                position: 'top',
                style: {
                    colors: ['var(--textPrimary)'],
                },
            },
            xaxis: {
                categories: labels,
                labels: {
                    style: {
                        colors: 'var(--textPrimary)',
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        colors: 'var(--textPrimary)',
                    },
                },
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                labels: {
                    colors: 'var(--text)',
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: '100%',
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
        },
    });

    return (
        <div>
            <div id="chart">
                <h1 className='italic font-bold underline text-[var(--textPrimary)]'>{title}</h1>
                <ReactApexChart options={chartData.options} series={chartData.series} type="bar" />
            </div>
        </div>
    );
}

export default BarChart;